import { keyframes, styled } from '@mui/material';
export const AnimationBlink = styled('div')(({}) => ({
    animation: `3s infinite  ${keyframes `
    10%{
        opacity: 0.3
      }
`}`,
}));
